module.exports = __webpack_public_path__ + "static/444937dc481c1ca583dd745d3a6625b8b1253f5aa7d0d4d53c148a64461bab2b-a7dfcab4dde7f9ae2430e8a80d3440eb.png";